"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _AlertBoxModule = _interopRequireDefault(require("./AlertBox.module.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const AlertHeader = _ref => {
  let {
    header
  } = _ref;
  if (header) {
    return /*#__PURE__*/_react.default.createElement("span", {
      className: _AlertBoxModule.default.alertHeader
    }, header);
  }
  return null;
};
var _default = exports.default = AlertHeader;